module.exports = __webpack_public_path__ + "static/img/zs3.b5922977.png";